
import { createI18n } from 'vue-i18n';

const messages = {
  de: {
	view: {
		dashboard: 'Dashboard',
		rechtsgrundlagen: 'Rechtsgrundlagen',
		rechtsgrundlage: 'Rechtsgrundlage',
		rgkuerzel: 'Rechtsgrundlagen Kürzel',
		rechtsaspekt: 'Rechtsaspekt',
		pflichten: 'Pflichten',
		pflicht: 'Pflicht',
		tasks: 'Aufgaben',
		notification: 'Benachrichtigung',
		task: 'Aufgabe',
		logs: 'Historie',
		excel: 'Excel',
		customers: 'Kunden',
		customer: 'Kunde',
		users: 'Nutzer',
		user: 'Nutzer',
		roles: 'Rollen',
		rights: 'Rechte',
		standorts: 'Standorte',
		standort: 'Standort',
		functions: 'Funktionen',
		function: 'Funktion',
		imports: 'Importe',
		gefahrstoffe: 'Gefahrstoffe',
		gefahrstoff: 'Gefahrstoff',
		settings:  'Einstellungen', 
		entries: 'Einträge',
		entriesperpage: 'Einträge pro Seite',
	  prev: 'Zurück',
	  next: 'Weiter',
	  page: 'Seite',
		self: 'Eigene',
	  of: 'von',
		columns: 'Spalten',
		columns_hs: 'Spalten ein-/ausblenden',
		reset_filter: 'Filter zurücksetzen',
		cleared_filter: 'Filter leer',
		filter_placeholder: 'Filter...',
		actions: 'Aktionen',
		all: 'Alle',
		rechtsaspect: 'Rechtsaspect',
		draghandle: 'Spalte umziehen',
		resizehandle: 'Spaltenbreite ändern',
		btn_rechtsgrundlagen: 'Rechtsgrundlagen',
		btn_pflichten: 'Pflichten',
    btn_rg_standardtexts: 'Standard Texts', 
		btn_edit: 'Bearbeiten in Tabelle',
		btn_detail: 'Details und Bearbeiten',
		btn_delete: 'Löschen',
		btn_cancel: 'Zurücksetzen',
		btn_save: 'Speichern',
		btn_saving: 'Speichern…',
		loading: 'Daten werden geladen…',
		btn_rights: 'Rechte konfigurieren',
		btn_sendpasswd: 'Einrichtungslink senden',
		btn_impersonate_user: 'Als Nutzer anmelden',
		sel_choose_right: 'Rechtekategorie wählen...',
		btn_rg_pflichten: 'Pflichten für {rg}',
		btn_rg_normify_update: 'Rechtsgrundlage mit Normify aktualisieren: {rg}',
		rg_normify_update_title: 'Normify-Aktualisierung',
		rg_normify_update_description: 'Rechtsgrundlage mit Normify aktualisieren: {rg}',
		rg_normify_update_choice: 'Sollen bestehende Daten mit Normify ersetzt werden oder sollen nur fehlende Felder ergänzt werden?',
		rg_normify_update_fill_missing: 'Nur fehlende ergänzen',
		rg_normify_update_overwrite: 'Überschreiben',
		rg_normify_debug_title: 'Vergleich',
		rg_normify_debug_hmc: 'HMC-Intern',
		rg_normify_debug_mode: 'Modus',
		rg_normify_debug_changed: 'Geändert',
		rg_normify_debug_standardtexts: 'Standardtexte erstellt/aktualisiert/übersprungen/fehlgeschlagen',
		rg_normify_debug_pflichten: 'Pflichten erstellt/aktualisiert/übersprungen/fehlgeschlagen',
		rg_normify_debug_field: 'Feld',
		rg_normify_debug_old: 'Alt',
		rg_normify_debug_new: 'Neu',
		rg_normify_debug_empty: 'Keine Rechtsgrundlagen-Felder wurden geändert.',
		rg_normify_debug_show_json: 'API JSON',
		rg_normify_debug_hide_json: 'API JSON verbergen',
		rg_normify_debug_json_title: 'API Ergebnis',
		btn_excel: 'Excel generieren',
		btn_quenticexcel: 'Quentic Excel generieren',
		btn_logdetails: 'Log Details',
		btn_workflow: 'Daten aktualisieren',
		btn_workflow_clear: 'Feld Workflow zurücksetzen',
		btn_duplicate_customer: 'Muster GmbH duplizieren',
		btn_comments: 'Kommentare',
		btn_notification: 'Benachrichtigung öffnen',
		btn_notification_add: 'Benachrichtigung hinzufügen',
	  customer_assignment: 'Kundenzuweisung',
		function_assignment: 'Funktionszuweisung',
		user_assignment: 'Personenzuweisung',
		edit_notification: 'Benachrichtigung bearbeiten',
		logdetails: 'Details',
		comments: 'Kommentare',
    addcomment: 'Kommentar hinzufügen',
		add: 'hinzufügen',
		logout: 'Abmelden',
		assignment: 'Zuweisung',
		none: 'Keine',
		own: 'Eigene',
		copy: 'Kopieren',
    sendemail: 'Per E-Mail benachrichtigen',
		edit: 'Bearbeite',
		hide: 'Verstecke',
		collapse: 'Einklappen',
    close: 'Schließen',
    customer_duplicate_title: 'Muster GmbH duplizieren',
    customer_duplicate_description: 'Neuen Kundennamen eingeben.',
    customer_duplicate_name: 'Neuer Kundenname',
    customer_duplicate_submit: 'Duplizieren',
    customer_duplicate_started: 'Muster GmbH wird dupliziert...',
    customer_duplicate_done: 'Duplizierung abgeschlossen.',
    customer_duplicate_failed: 'Duplizierung fehlgeschlagen.',
    customer_duplicate_name_required: 'Bitte einen Kundennamen eingeben.',
    customer_duplicate_new_id: 'Neue Kunden-ID:',
    login: 'Anmeldung',
    yes: 'Ja',
    no: 'Nein',
		user_set_inactive_confirm: 'Diesen Nutzer deaktivieren? Er kann sich nicht mehr anmelden und erscheint für Kunden nicht mehr in der Nutzerliste.',
		user_set_inactive_title: 'Nutzer deaktiviert',
		user_set_inactive_desc: 'Der Nutzer ist jetzt inaktiv.',
	},
    projects: {
      add: 'Add Project',
      delete: 'Delete Project'
    }
  },
  en: {
    view: {
      dashboard: 'Dashboard',
      rechtsgrundlagen: 'Laws',
      rechtsgrundlage: 'Law',
      rgkuerzel: 'Law Abbreviation',
      rechtsaspekt: 'Legal Aspect',
      pflichten: 'Duties',
      pflicht: 'Duty',
      tasks: 'Tasks',
      notification: 'Notification',
      task: 'Task',
      logs: 'History',
      excel: 'Excel',
      customers: 'Customers',
      customer: 'Customer',
      users: 'Users',
      user: 'User',
      roles: 'Roles',
      rights: 'Rights',
      standorts: 'Locations',
      standort: 'Location',
      functions: 'Functions',
      function: 'Function',
      imports: 'Imports',
      gefahrstoffe: 'Hazardous Substances',
      gefahrstoff: 'Hazardous Substance',
      settings: 'Settings',
      entries: 'Entries',
      entriesperpage: 'Entries per page',
      prev: 'Previous',
      next: 'Next',
      page: 'Page',
      self: 'Own',
      of: 'of',
      columns: 'Columns',
      columns_hs: 'Show/hide columns',
      reset_filter: 'Reset filter',
      cleared_filter: 'Filter cleared',
      filter_placeholder: 'Filter...',
      actions: 'Actions',
      all: 'All',
      rechtsaspect: 'Legal Aspect',
      draghandle: 'Drag column',
      resizehandle: 'Change column width',
      btn_rechtsgrundlagen: 'Laws',
      btn_pflichten: 'Duties',
      btn_edit: 'Edit in table',
      btn_detail: 'Details and Edit',
      btn_delete: 'Delete',
      btn_cancel: 'Reset',
      btn_save: 'Save',
      btn_saving: 'Saving…',
      loading: 'Loading Data…',
      btn_rights: 'Configure rights',
      btn_sendpasswd: 'Send setup link',
      btn_impersonate_user: 'Log in as user',
      sel_choose_right: 'Choose right category...',
      btn_rg_pflichten: 'Duties for {rg}',
      btn_rg_normify_update: 'Update law from Normify: {rg}',
      rg_normify_update_title: 'Normify update',
      rg_normify_update_description: 'Update law from Normify: {rg}',
      rg_normify_update_choice: 'Should existing data be replaced with Normify data, or should only missing fields be filled?',
      rg_normify_update_fill_missing: 'Fill missing only',
      rg_normify_update_overwrite: 'Overwrite',
      rg_normify_debug_title: 'Comparison',
      rg_normify_debug_hmc: 'HMC internal',
      rg_normify_debug_mode: 'Mode',
      rg_normify_debug_changed: 'Changed',
      rg_normify_debug_standardtexts: 'Standard texts created/updated/skipped/failed',
      rg_normify_debug_pflichten: 'Duties created/updated/skipped/failed',
      rg_normify_debug_field: 'Field',
      rg_normify_debug_old: 'Old',
      rg_normify_debug_new: 'New',
      rg_normify_debug_empty: 'No law fields were changed.',
      rg_normify_debug_show_json: 'API JSON',
      rg_normify_debug_hide_json: 'Hide API JSON',
      rg_normify_debug_json_title: 'API result',
      btn_excel: 'Generate Excel',
      btn_quenticexcel: 'Generate Quentic Excel',
      btn_logdetails: 'Log Details',
      btn_workflow: 'Update data',
      btn_workflow_clear: 'Reset workflow field',
      btn_duplicate_customer: 'Duplicate Muster GmbH',
      btn_comments: 'Comments',
      btn_notification: 'Open notification',
      btn_notification_add: 'Add notification',
      customer_assignment: 'Customer assignment',
      function_assignment: 'Function assignment',
      user_assignment: 'Person assignment',
      edit_notification: 'Edit notification',
      logdetails: 'Details',
      comments: 'Comments',
      addcomment: 'Add comment',
      add: 'add',
      logout: 'Logout',
      assignment: 'Assignment',
      none: 'none',
      own: 'Own',
      copy: 'Copy',
      sendemail: 'Notify',
      edit: 'Edit',
      hide: 'Hide',
      collapse: 'Collapse',
      close: 'Close',
      customer_duplicate_title: 'Duplicate Muster GmbH',
      customer_duplicate_description: 'Enter the new customer name.',
      customer_duplicate_name: 'New customer name',
      customer_duplicate_submit: 'Duplicate',
      customer_duplicate_started: 'Duplicating Muster GmbH...',
      customer_duplicate_done: 'Duplication complete.',
      customer_duplicate_failed: 'Duplication failed.',
      customer_duplicate_name_required: 'Please enter a customer name.',
      customer_duplicate_new_id: 'New customer ID:',
      yes: 'Yes',
      no: 'No',
      user_set_inactive_confirm: 'Deactivate this user? They will not be able to sign in and will be hidden from the customer user list.',
      user_set_inactive_title: 'User deactivated',
      user_set_inactive_desc: 'The user is now inactive.',
    },
    projects: {
      add: 'Add Project',
      delete: 'Delete Project'
    }
  },
  'zh-TW': {
    view: {
      dashboard: '仪表板',
      rechtsgrundlagen: '法律',
      rechtsgrundlage: '法律',
      rgkuerzel: '法律缩写',
      rechtsaspekt: '法律方面',
      pflichten: '义务',
      pflicht: '义务',
      tasks: '任务',
      notification: '通知',
      task: '任务',
      logs: '历史',
      excel: 'Excel',
      customers: '客户',
      customer: '客户',
      users: '用户',
      user: '用户',
      roles: '角色',
      rights: '权限',
      standorts: '位置',
      standort: '位置',
      functions: '功能',
      function: '功能',
      imports: '导入',
      gefahrstoffe: '危险物质',
      gefahrstoff: '危险物质',
      settings: '设置',
      entries: '条目',
      entriesperpage: '每页条目数',
      prev: '上一页',
      next: '下一页',
      page: '页',
      self: '自己的',
      of: '的',
      columns: '列',
      columns_hs: '显示/隐藏列',
      reset_filter: '重置筛选器',
      cleared_filter: '筛选器已清除',
      filter_placeholder: '筛选...',
      actions: '操作',
      all: '全部',
      rechtsaspect: '法律方面',
      draghandle: '拖动列',
      resizehandle: '更改列宽',
      btn_rechtsgrundlagen: '法律',
      btn_pflichten: '义务',
      btn_edit: '在表格中编辑',
      btn_detail: '详情和编辑',
      btn_delete: '删除',
      btn_cancel: '重置',
      btn_save: '保存',
      btn_saving: '保存中…',
      loading: '加载中…',
      btn_rights: '配置权限',
      btn_sendpasswd: '发送设置链接',
      btn_impersonate_user: '以用户身份登录',
      sel_choose_right: '选择权限类别...',
      btn_rg_pflichten: '{rg}的义务',
      btn_rg_normify_update: '从 Normify 更新法律：{rg}',
      rg_normify_update_title: 'Normify 更新',
      rg_normify_update_description: '从 Normify 更新法律：{rg}',
      rg_normify_update_choice: '要用 Normify 数据替换现有数据，还是只填写缺失字段？',
      rg_normify_update_fill_missing: '仅填写缺失项',
      rg_normify_update_overwrite: '覆盖',
      rg_normify_debug_title: '对比',
      rg_normify_debug_hmc: 'HMC 内部编号',
      rg_normify_debug_mode: '模式',
      rg_normify_debug_changed: '已更改',
      rg_normify_debug_standardtexts: '标准文本 创建/更新/跳过/失败',
      rg_normify_debug_pflichten: '义务 创建/更新/跳过/失败',
      rg_normify_debug_field: '字段',
      rg_normify_debug_old: '旧值',
      rg_normify_debug_new: '新值',
      rg_normify_debug_empty: '没有法律字段被更改。',
      rg_normify_debug_show_json: 'API JSON',
      rg_normify_debug_hide_json: '隐藏 API JSON',
      rg_normify_debug_json_title: 'API 结果',
      btn_excel: '生成Excel',
      btn_quenticexcel: '生成Quentic Excel',
      btn_logdetails: '日志详情',
      btn_workflow: '更新数据',
      btn_workflow_clear: '重置工作流字段',
      btn_duplicate_customer: '复制 Muster GmbH',
      btn_comments: '评论',
      btn_notification: '打开通知',
      btn_notification_add: '添加通知',
      customer_assignment: '客户分配',
      function_assignment: '功能分配',
      user_assignment: '人员分配',
      edit_notification: '编辑通知',
      logdetails: '详情',
      comments: '评论',
      addcomment: '添加评论',
      add: '添加',
      logout: '登出',
      assignment: '分配',
      none: '无',
      own: '自己的',
      copy: '复制',
      sendemail: '通知',
      edit: '编辑',
      hide: '隐藏',
      collapse: '折叠',
      close: '关闭',
      customer_duplicate_title: '复制 Muster GmbH',
      customer_duplicate_description: '输入新的客户名称。',
      customer_duplicate_name: '新客户名称',
      customer_duplicate_submit: '复制',
      customer_duplicate_started: '正在复制 Muster GmbH...',
      customer_duplicate_done: '复制完成。',
      customer_duplicate_failed: '复制失败。',
      customer_duplicate_name_required: '请输入客户名称。',
      customer_duplicate_new_id: '新客户 ID:',
      yes: '是',
      no: '否',
      user_set_inactive_confirm: '要停用此用户吗？他们将无法登录，且不会出现在客户的用户列表中。',
      user_set_inactive_title: '用户已停用',
      user_set_inactive_desc: '该用户现已停用。',
    },
    projects: {
      add: '添加项目',
      delete: '删除项目'
    }
  },
};

// Get saved locale from localStorage, default to 'de'
const getInitialLocale = () => {
  if (typeof window !== 'undefined') {
    const savedLocale = localStorage.getItem('app_locale')
    if (savedLocale && (savedLocale === 'de' || savedLocale === 'en' || savedLocale === 'zh-TW')) {
      return savedLocale
    }
  }
  return 'de'
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages
});

export default i18n;
